import { API, authClient } from "../index";

// Get all faqs
export const getAllFaqs = () => {
    return authClient().get(`${API}/faq/`);
};

// Get faq by id
export const getFaqById = (id) => {
    return authClient().get(`${API}/faq/${id}`);
};

// Delete faq
export const deleteFaq = (id) => {
    return authClient().delete(`${API}/faq/${id}`);
};

export const swapOrdersFaq = async (id1, id2) => {
    return authClient().post(`${API}/faq/swap-orders`, { id1, id2 });
};

// Create faq
export const postFaq = async (faq) => {
    return authClient().post(`${API}/faq`, faq);
};

// Update faq
export const updateFaq = async (id, faq) => {
    return authClient().put(`${API}/faq/${id}`, faq);
};